import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class ResourceInventoryEmptyStateComponent extends Component {
  @tracked isCreateParkingModalOpen = false;
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  get shouldShowAddParkingModal(): boolean {
    return this.isCreateParkingModalOpen && this.featureFlags.isEnabled('add-unplaced-parking');
  }

  @action
  handleAddResource(): void {
    if (this.featureFlags.isEnabled('add-unplaced-parking')) {
      this.isCreateParkingModalOpen = true;
    } else {
      this.router.transitionTo('spaces.maps.edit');
    }
  }

  @action
  handleCloseCreateParkingModal(): void {
    this.isCreateParkingModalOpen = false;
  }
}
